import { ORG_PAGE_UNAVAILABLE_TEXT } from "@buildpy/core/modules/org/status";

import { OrgLinkUnavailableNotice, orgAccessFailureOf } from "@/components/org-access-notice";
import LinkError from "@/modules/share/ui/link-error";

// 소개 링크 화면 오류 — 조직 막힘(403 org_unavailable)만 갈라내고 error.message·digest 는 보이지 않는다(내부 정보가 화면에 새지 않게).
const ReferralLinkError = ({ error, reset }: { error?: unknown; reset: () => void }) =>
  orgAccessFailureOf(error)?.kind === "unavailable" ? <OrgLinkUnavailableNotice title={ORG_PAGE_UNAVAILABLE_TEXT} /> : <LinkError reset={reset} />;

export default ReferralLinkError;
